<template>
  <div v-if="loading"></div>

  <v-container v-else>
    <v-breadcrumbs :items="crumbs">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="poll.pollText"
                label="Poll Question"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10"><h3>Choices</h3></v-col>
            <v-col cols="2"
              ><v-icon @click="addAnswer()" class="mr-2"
                >mdi-plus-circle</v-icon
              ></v-col
            >
          </v-row>
          <v-row v-if="editNotAllowed"
            ><v-col
              >Warning: You are modifying a poll with responses.
            </v-col></v-row
          >
          <v-row
            no-gutters
            v-for="(item, index) of poll.answers"
            v-bind:key="index"
          >
            <v-col cols="10">
              <v-text-field
                placeholder="empty"
                v-model="poll.answers[index].title"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-icon @click="deleteAnswer(index)" class="mt-6"
                >mdi-delete</v-icon
              >
            </v-col>
          </v-row>

          <v-row class="mt-5">
            <v-col cols="12"><h3>Settings</h3></v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12">
              <v-switch
                dense
                label="Require Authentication"
                v-model="poll.requireAuth"
              ></v-switch>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12">
              <v-switch
                dense
                label="Ignore proxies"
                v-model="poll.ignoreProxy"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-switch
                dense
                label="Allow multiple responses"
                v-model="poll.multiple"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-switch
                dense
                label="Allow edit response"
                v-model="poll.allowEdit"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-radio-group
                row
                v-model="poll.showResults"
                label="Show results:"
              >
                <v-radio dense label="Hide" value="hide"></v-radio>
                <v-radio dense label="When closed" value="closed"></v-radio>
                <v-radio dense label="Always" value="always"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row no-gutters v-show="poll.multiple">
            <v-col cols="2" class="mr-5">
              <v-text-field
                outlined
                type="number"
                v-model="poll.multipleMin"
                label="Min"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                type="number"
                v-model="poll.multipleMax"
                label="Max"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <h3>Filter by tags</h3>
              <p>Users must have matching tags to vote this poll</p>
              <Tags v-model="poll.tags" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary darken-1" @click="save">Save</v-btn>
        <v-btn color="primary darken-1" @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Tags from "./Tags";
export default {
  components: {
    Tags
  },
  data: () => {
    return {
      loading: false,
      crumbs: [
        {
          text: "Home",
          to: "/admin",
          exact: true
        },
        {
          text: "Polls",
          to: "/admin/polls",
          exact: true
        },
        {
          text: "Add/Edit poll",
          exact: true,
          disabled: true
        }
      ],
      poll: {},
      formDefaults: {
        answers: [{ title: "" }],
        multiple: false,
        multipleMin: 1,
        multipleMax: -1,
        tags: [],
        sort: 0
      }
    };
  },
  computed: {
    formTitle: function() {
      return this.poll._id === undefined ? "New Poll" : "Edit Poll";
    },
    editNotAllowed: function() {
      return this.poll.answers.filter((answer) => answer.count > 0).length > 0;
    }
  },
  async created() {
    this.poll = Object.assign({}, this.formDefaults);

    if (!this.$route.params.pollId) return;

    this.loading = true;
    this.poll = await this.$store.dispatch(
      "loadPoll",
      this.$route.params.pollId
    );
    this.loading = false;
  },
  methods: {
    async save() {
      if (this.poll._id) {
        await this.$store.dispatch("savePoll", this.poll);
      } else {
        await this.$store.dispatch("createPoll", this.poll);
      }
      this.close();
    },
    async deleteAnswer(index) {
      this.poll.answers.splice(index, 1)[0];
    },
    addAnswer() {
      this.poll.answers.push({ title: "", sort: 0, count: 0 });
    },
    close() {
      this.$router.replace("/admin/polls");
    }
  }
};
</script>
